import React from "react";
import { Link } from "react-router-dom";
import { homePageV2Footer } from "../content/homePageV2Content";

export function FooterCtaSectionV2() {
  const { links } = homePageV2Footer;

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();
    // TODO: newsletter / marketing API
  };

  return (
    <footer className="mh2v2-footer">
      <div className="mh2v2-container mh2v2-footer__grid">
        <div className="mh2v2-footer__links">
          {links.map((item) => (
            <Link key={item.label} to={item.to}>
              {item.label}
            </Link>
          ))}
        </div>

        <div className="mh2v2-footer__brand">
          <div className="mh2v2-round-logo">M</div>
          <div className="mh2v2-socials">
            <span>f</span>
            <span>ig</span>
            <span>in</span>
          </div>
        </div>

        <form className="mh2v2-newsletter" onSubmit={handleNewsletterSubmit}>
          <h4>NEWSLETTER SIGN-UP!</h4>
          <div className="mh2v2-newsletter__row">
            <input type="text" placeholder="First Name" aria-label="First Name" />
            <input type="text" placeholder="Last Name" aria-label="Last Name" />
          </div>
          <input type="email" placeholder="Email Address" aria-label="Email Address" />
          <button type="submit" className="mh2v2-pill mh2v2-pill--gold">
            Submit →
          </button>
        </form>
      </div>
    </footer>
  );
}

export default FooterCtaSectionV2;
